/**
 * Google Tag Manager + dataLayer helper
 * GTM ID: GTM-W8FTRVVJ (live) — update if needed
 * GA4 ID: G-RED75Z8606
 * Google Ads: AW-413089823
 */

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

// Ensure dataLayer exists (guarded: this module is also evaluated during SSR)
if (typeof window !== "undefined") {
  window.dataLayer = window.dataLayer || [];
}

type GTMEvent =
  | "page_view"
  | "cta_click"
  | "call_click"
  | "form_start"
  | "form_submit"
  | "form_success"
  | "quote_request"
  | "book_consultation";

interface GTMPayload {
  event: GTMEvent;
  [key: string]: unknown;
}

export function pushEvent(event: GTMEvent, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer.push({ event, ...params });
}

// Convenience helpers
export const gtm = {
  pageView: (path: string, title?: string) =>
    pushEvent("page_view", {
      page_path: path,
      page_title: title || document.title,
      page_location: window.location.href,
    }),

  ctaClick: (ctaId: string, ctaText?: string) =>
    pushEvent("cta_click", { cta_id: ctaId, cta_text: ctaText }),

  callClick: (phoneNumber: string, source?: string) =>
    pushEvent("call_click", {
      phone_number: phoneNumber,
      click_source: source,
      conversion_id: "AW-413089823",
    }),

  formStart: (formId: string) =>
    pushEvent("form_start", { form_id: formId }),

  formSubmit: (formId: string) =>
    pushEvent("form_submit", { form_id: formId }),

  formSuccess: (formId: string, extra?: Record<string, unknown>) =>
    pushEvent("form_success", { form_id: formId, ...extra }),

  quoteRequest: (source: string) =>
    pushEvent("quote_request", { request_source: source, conversion_id: "AW-413089823" }),

  bookConsultation: (date?: string, time?: string) =>
    pushEvent("book_consultation", {
      booking_date: date,
      booking_time: time,
      conversion_id: "AW-413089823",
    }),
};
